/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable radix */
/* eslint-disable consistent-return */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import {
  Search, Filter, Download, ReportMoney, ArrowUpRight, ArrowDownRight,
} from 'tabler-icons-react';
import {
  TextInput, Tooltip, useMantineColorScheme,
} from '@mantine/core';
import { Card, ConfigProvider } from 'antd';
import { assetPrefix, renderNumber, displayDateV2 } from '../../../utilities/general';
import CustomSelect from '../../Listing/companyData/Select';
import CalenderIcon from '../../../components/CommonFunction/CalenderIcon';
import styles from './PositionsTabV2.module.css';

export default function ClosedPositionsTabV2(props) {
  const [searchValue, setSearchValue] = useState('');
  const { colorScheme } = useMantineColorScheme();

  const [selectOptions, setSelectOptions] = useState('all');

  const data = [
    { value: 'all', label: 'All Time' },
    { value: '30 days', label: 'Last 30 days' },
    { value: '7 days', label: 'Last 7 days' },
    { value: 'profit', label: 'Profitable Only' },
    { value: 'loss', label: 'Losses Only' },
  ];

  const positionsData = [
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Binance',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Short',
      platform: 'Kraken',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Binance',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: 67.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: 234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
    {
      asset: 'ETH',
      tradingProductType: 'Ethereum',
      icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png',
      direction: 'Long',
      platform: 'Coinbase',
      totalInvestment: { symbol: 'USD', assetValue: 18450 },
      valueOpenPositions: 18215.44,
      runningPnL: {
        symbol: 'USD',
        assetValue: -234.56,
        usdValue: -234.56,
      },
      change: {
        percentage: -1.27,
        asset: -1.27,
      },
      closedTimestamp: '2025-03-19 23:49:27.452623',
    },
  ];

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: {
            bodyPadding: 16,
            borderRadiusLG: 14,
          },
        },
      }}
    >
      <div>
        <div className="flex flex-col gap-6 mx-auto">
          <div className="flex flex-col gap-1">
            <h1 className="text-2xl font-bold text-[#101828] dark:text-white">Closed Positions</h1>
            <p className="text-base font-normal text-[#4A5565] dark:text-[#898989]">Review your completed trading positions and performance</p>
          </div>
          <div className="grid grid-cols-3 gap-4">
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Total Closed</div>
              <div className="text-2xl font-bold text-[#101828] dark:text-[#BEB9B9]">
                5
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Total Invested</div>
              <div className="text-2xl font-bold text-[#101828] dark:text-[#BEB9B9]">
                {renderNumber(75300, true) || '0.00'}
              </div>
            </Card>
            <Card className={`text-left ${colorScheme === 'dark' && 'bg-[#26282C] border-[#26282C]'}`}>
              <div className="text-sm text-[#4A5565] dark:text-[#898989]">Final Value</div>
              <div className="text-2xl font-bold text-[#009966]">
                {renderNumber(80026.33, true) || '0.00'}
              </div>
            </Card>
          </div>
          <div className="flex flex-col items-start gap-[46px] rounded-[14px] bg-white dark:bg-[#26282C] p-6 shadow-md flex-shrink-0 self-stretch">
            <div className="w-full flex justify-between items-center">
              <div className="h-9 flex justify-center items-start gap-4">
                <TextInput
                  classNames={{
                    input: 'bg-[#FAFAFA] dark:bg-[#1a1b1e] dark:border-neutral-600 border-[#E5E7EB]',
                  }}
                  className="w-80"
                  placeholder="Search closed positions..."
                  radius="md"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e.currentTarget.value)}
                  icon={<Search size={16} color="#99A1AF" />}
                />
                <CustomSelect
                  options={data}
                  value={selectOptions}
                  onChange={setSelectOptions}
                  // icon={<Filter size={16} color="#717182" />}
                  icon={<CalenderIcon size={16} />}
                />
              </div>
              <div className={`${styles.padding} border border-[#0000001A] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-lg`}>
                <Download size={16} color={colorScheme === 'dark' ? '#898989' : '#0A0A0A'} />
                <span className="text-sm font-medium text-[#0A0A0A] dark:text-[#898989]">Export</span>
              </div>
            </div>
            <div className={`${styles.grid} w-full h-full flex flex-col items-start border border-[#F3F4F6] dark:border-neutral-600 dark:bg-[#1a1b1e] rounded-[10px]`}>
              <div className={`w-full h-10 grid items-center p-2 rounded-t-lg border-b border-[#0000001A] dark:border-neutral-600 bg-[#F9FAFB80] dark:bg-[#1a1b1e] ${styles.PositionsTabHeadingGrid}`}>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Asset
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Total Investment
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Current Status
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Final Value of Closed Position
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Change
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Closed Timestamp
                </div>
                <div className="text-sm text-[#101828] dark:text-[#898989] font-semibold">
                  Platform
                </div>
              </div>
              {positionsData.map((items) => (
                <div className={`w-full h-[73px] grid items-center p-2 rounded-t-lg border-b border-[#0000001A] dark:border-neutral-600 last:border-none ${styles.PositionsTabRowGrid}`}>
                  <div className="flex items-center gap-3 text-base font-normal">
                    {items?.icon
                      ? (
                        <img
                          className="w-8 h-8 rounded-full"
                          src={items?.icon || `${assetPrefix}/images/CrptoIcon.svg`}
                          alt="Crypto"
                        />
                      )
                      : <ReportMoney className="w-11 h-11" />}

                    <div className="flex flex-col gap-1">
                      <span
                        className={`${styles.title} font-semibold text-[#101828] dark:text-[#898989]`}
                      >
                        {items?.asset?.length > 8 ? `${items?.asset?.slice(0, 8)}...` : items?.asset.toUpperCase() || '-'}
                      </span>
                      <span
                        className={`${styles.subTitle}`}
                      >
                        {items?.tradingProductType}
                      </span>
                    </div>
                  </div>
                  <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                    {renderNumber(items?.totalInvestment.assetValue, true)}
                  </div>
                  <div className={`${styles.title} font-medium ${items?.runningPnL.assetValue > 0 ? 'text-[#009966]' : 'text-[#E7000B]'}`}>
                    <div className="flex items-center gap-1">
                      {items?.runningPnL.assetValue > 0 ? (
                        <ArrowUpRight size={16} className="text-[#009966]" />
                      ) : (
                        <ArrowDownRight size={16} className="text-[#FB2C36]" />
                      )}
                      <span>{renderNumber(items?.runningPnL.assetValue, true)}</span>
                    </div>
                  </div>
                  <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                    {renderNumber(items?.valueOpenPositions, true)}
                  </div>
                  <div className={`${styles.title} flex items-center gap-1 font-medium ${items?.change.percentage > 0 ? 'text-[#009966]' : 'text-[#E7000B]'}`}>
                    {items?.change.percentage > 0 ? (
                      <ArrowUpRight size={12} className="text-[#009966]" />
                    ) : (
                      <ArrowDownRight size={12} className="text-[#FB2C36]" />
                    )}
                    <span>{`${renderNumber(items?.change.percentage)}%`}</span>
                  </div>
                  <div className={`${styles.title} font-medium text-[#101828] dark:text-[#898989]`}>
                    {displayDateV2(items?.closedTimestamp)}
                  </div>
                  <div className="w-fit py-1 px-2 text-xs bg-[#F9FAFB] rounded-lg border border-[#0000001A] font-medium text-[#0A0A0A]">
                    {items.platform}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
}
